import { z } from "zod";

import {
  DiscountApplicationMethodList,
  DiscountDiscountTypeList,
  DiscountUnitTypeList,
} from "./offers";

const ProductListSchema = z.object({
  rule: z.enum(["whitelist", "blacklist"]),
  list: z.array(z.string()).default([]),
});

const TierSchema = z.object({
  miU: z.number(),
  maU: z.number().optional(),
  uD: z.number(),
  m: z.string().nullable(),
});

export type TierMetafieldType = z.infer<typeof TierSchema>;

const DiscountMetafieldConfigSchema = z.object({
  unitType: z.enum(DiscountUnitTypeList).default("dollar"),
  discountType: z.enum(DiscountDiscountTypeList).default("dollar"),
  discountApplicationMethod: z
    .enum(DiscountApplicationMethodList)
    .default("perItem"),
  productList: ProductListSchema,
  tiers: TierSchema.array(),
});

export type DiscountMetafieldConfigType = z.infer<
  typeof DiscountMetafieldConfigSchema
>;

const CampaignMetafieldSchema = z.object({
  id: z.string(),
  eP: z.boolean(),
  iP: z.boolean(),
  pL: z.array(z.string()).optional(), //.default([]),
  uT: z.enum(DiscountUnitTypeList).default("dollar"),
  dT: z.enum(DiscountDiscountTypeList).default("dollar"),
  dAM: z.enum(DiscountApplicationMethodList).default("perItem"),
  mDD: z.number().nullable().optional(),
  t: TierSchema.array().default([]),
  rL: z.boolean().default(false),
  sS: z.boolean().default(false),
});

export type CampaignMetafieldType = z.infer<typeof CampaignMetafieldSchema>;

const ExperienceMetafieldSchema = z.object({
  id: z.string(),
  variationIds: z.string().array(),
});

export type ExperienceMetafieldType = z.infer<typeof ExperienceMetafieldSchema>;
